import { faMegaphone } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@material-ui/core";
import * as Sentry from "@sentry/react";
import { useEffect, useRef, useState } from "react";
const ToggleFeedbackButton = () => {
  const [feedback] = useState(() => Sentry.getFeedback());
  const buttonRef = useRef<HTMLAnchorElement>();
  useEffect(() => {
    if (buttonRef.current) {
      const unsubscribe = feedback?.attachTo(buttonRef.current);
      return () => {
        unsubscribe?.();
      };
    }
    return;
  }, [buttonRef, feedback]);
  return <Tooltip title="Report a Bug" data-sentry-element="Tooltip" data-sentry-component="ToggleFeedbackButton" data-sentry-source-file="ToggleFeedbackButton.tsx">
            <IconButton aria-label="theme" color="inherit" ref={buttonRef as any} data-sentry-element="IconButton" data-sentry-source-file="ToggleFeedbackButton.tsx">
                <FontAwesomeIcon icon={faMegaphone} fixedWidth data-sentry-element="FontAwesomeIcon" data-sentry-source-file="ToggleFeedbackButton.tsx" />
            </IconButton>
        </Tooltip>;
};
export default ToggleFeedbackButton;